import ActionCardGridView from "@/components/actions/ActionCardGridView";
import { useFeatureTypeName } from "@/hooks/useFeatureTypeName";
import type { LayoutContext } from "@/lib/models";
import { featureTypeCreateActionUrlBuilder } from "@/lib/url-builder";
import { Action, ActionService } from "@/services/ActionService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const FeatureTypeActionListPage: React.FC = () => {
  const [actionList, setActionsList] = useState<Action[]>([]);
  const params = useParams();
  const { featureTypeName } = useFeatureTypeName(params.featureTypeId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Feature Type: ${featureTypeName} Tasks`);
    }, [featureTypeName, setPageName]);

  useEffect(() => {
    ActionService
      .getByFeatureTypeId(params.featureTypeId!)
      .then(setActionsList);
  }, [params.featureTypeId]);

  return (
    <div className="container mx-auto p-4">
      <ActionCardGridView actionsList={actionList} title={`Feature Type: ${featureTypeName}`} createUrl={featureTypeCreateActionUrlBuilder(params.siteId!, params.featureTypeId!)} />
    </div>
  );
};

export default FeatureTypeActionListPage;
